import type { InsuranceParamsDto, InsuranceParamsTravelDto, PolicyHolderDto } from 'BrokerTsLib/src/dtos'

import { FormLabel } from '@/components/FormLabel'
import { FormRow } from '@/containers/forms/FormRow'
import { PersonForm } from '@/containers/forms/PersonForm'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { useNameof } from '@/hooks/useNameof'
import { useGetBirthdate } from '@/hooks/useUser'
import { FormControl, FormHelperText, Switch } from '@chakra-ui/react'
import { Selection } from 'BrokerTsLib/src/enums'
import { newUid } from 'BrokerTsLib/src/helpers/global'
import { useFormContext } from 'BrokerTsLib/src/rhf'
import { isIn } from 'BrokerTsLib/src/Utils/comparisonUtils'
import { useEffect, useState } from 'react'

export const PolicyHolderForm = () => {
  const { isDisabled } = useInsuranceParams()

  const methods = useFormContext<InsuranceParamsTravelDto>()
  const {
    watch,
    setValue,
    getValues,
    trigger
  } = methods

  const phType = watch('policyHolder.person.type')
  const insurees = watch('travel.insurees') ?? []
  const firstname = watch('policyHolder.person.name')
  const surname = watch('policyHolder.person.surname')
  const birthdate = watch('policyHolder.person.birthday')
  const birthnumber = watch('policyHolder.person.birthNumber')
  const isForeigner = watch('policyHolder.person.isForeigner')

  const [isPolicyHolderInsureed, setIsPolicyHolderInsureed] = useState(insurees.findIndex(x => x.isPolicyHolder) >= 0)

  const nameof = useNameof<InsuranceParamsDto>()
  const phnameof = useNameof<PolicyHolderDto>(nameof(x => x.policyHolder))

  useEffect(() => {
    if (!isPolicyHolderInsureed) return

    const i = insurees.findIndex(x => x.isPolicyHolder)

    const ph = {
      firstName: firstname,
      lastName: surname,
      birthdate: birthdate,
      birthnumber: isForeigner ? undefined : birthnumber,
      isPolicyHolder: true,
      isForeigner: isForeigner
    }

    if (i >= 0)
      insurees[i] = { ...insurees[i], ...ph }

    setValue('travel.insurees', [...insurees])
  }, [firstname, surname, birthdate, birthnumber, isForeigner])

  const handleChangeIsPolicyHolder = (isPolicyHolder: boolean) => {
    setIsPolicyHolderInsureed(isPolicyHolder)

    const i = insurees.findIndex(x => x.isPolicyHolder)

    if (!isPolicyHolder) {
      insurees?.splice(i, 1)
    } else {
      const ph = {
        firstName: firstname,
        lastName: surname,
        birthdate: birthdate,
        birthnumber: isForeigner ? undefined : birthnumber,
        isPolicyHolder: true,
        isForeigner: isForeigner
      }

      // vychozi prazdny radek nahradim - tedy smazu a vlozim pojistnika
      if (insurees.length == 1
        && !insurees[0].firstName
        && !insurees[0].lastName
        && !insurees[0].birthdate
        && !insurees[0].birthnumber
      )
        insurees?.splice(0, 1)

      insurees.push({
        uid: newUid(),
        ...ph
      })
    }

    setValue('travel.insurees', [...insurees])
    trigger('travel.insurees')
  }

  const { refetch: getBirthdate } = useGetBirthdate(getValues('policyHolder.person.birthNumber'), { enabled: false })
  useEffect(() => {
    if (!(birthnumber && birthnumber.length >= 9 && birthnumber.length <= 10))
      return

    getBirthdate()
      .then(({ data }) => setValue('policyHolder.person.birthday', data?.data))
  }, [birthnumber, isForeigner]) // v pripade prepnuti z cizince na RC potrebuji prenastavit datum narozeni opet na zaklade RC


  return (
    <>
      <FormRow itemsCount={1}>
        <PersonForm personPrefix={phnameof(x => x.person)} disabled={isDisabled} useRuian={false} />

        {isIn(phType, Selection.Person, Selection.SelfEmployed) && insurees &&
          <FormControl>
            {/* <FormLabel sx={{ fontSize: 'sm' }}>Zahrnout do nabídky</FormLabel> */}

            {/* <FormLabel variant="switch"> */}
            <FormLabel gap={4}>
              Je zároveň pojištěnou osobou
              <Switch
                size="lg"
                dir="rtl"
                checked={isPolicyHolderInsureed}
                defaultChecked={isPolicyHolderInsureed}
                isDisabled={isDisabled}
                onChange={(e) => handleChangeIsPolicyHolder(e.target.checked)}
              // onChange={(e) => setIsPolicyHolderInsureed(e.target.checked)}
              />

            </FormLabel>

            <FormHelperText>
              Tuto možnost vyberte v případě, že je pojistník zároveň pojištěnou osobou
            </FormHelperText>
          </FormControl>

        }
      </FormRow>
    </>
  )
} 